import { pick, esc, printHtml } from './B2bPortalReportModal';

const money = (v) => Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const day = (d) => (d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—');

// builds a printable A4 invoice from the invoice detail the portal receives ({ header, items }) and prints it
export function printInvoice(detail) {
  const h = detail?.header || {};
  const items = detail?.items || [];
  const g = (...n) => pick(h, ...n);
  const rows = items
    .map(
      (it, i) => `<tr>
<td>${i + 1}</td>
<td>${esc(pick(it, 'ledgerTransactionNo'))}</td>
<td>${esc(pick(it, 'patientName'))}<br><small>${esc(day(pick(it, 'testDate')))}</small></td>
<td>${esc(pick(it, 'investigationName'))}</td>
<td>${esc(pick(it, 'sacCode') || '—')}</td>
<td class="r">${money(pick(it, 'rate'))}</td>
<td class="r">${money(pick(it, 'discountAmount'))}</td>
<td class="r">${money(pick(it, 'netAmount'))}</td></tr>`
    )
    .join('');
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Invoice ${esc(g('invoiceNumber'))}</title>
<style>
@page { size: A4; margin: 14mm; }
body { font-family: 'Segoe UI', Arial, sans-serif; color: #0f172a; font-size: 12px; }
.top { display: flex; justify-content: space-between; align-items: flex-start; border-bottom: 3px solid #1e3a8a; padding-bottom: 10px; margin-bottom: 14px; }
.top h1 { margin: 0; font-size: 20px; color: #1e3a8a; }
.top .sub { color: #64748b; margin-top: 2px; }
.doc { text-align: right; }
.doc .t { font-size: 22px; font-weight: 800; color: #1e3a8a; letter-spacing: 1px; }
.cols { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 14px; }
.box { border: 1px solid #cbd5e1; border-radius: 6px; padding: 10px 12px; }
.box h4 { margin: 0 0 6px; font-size: 10px; letter-spacing: .1em; text-transform: uppercase; color: #64748b; }
.box div { margin: 2px 0; }
table { width: 100%; border-collapse: collapse; }
th { background: #1e293b; color: #fff; text-align: left; padding: 7px 8px; font-size: 11px; }
td { padding: 7px 8px; border-bottom: 1px solid #e2e8f0; vertical-align: top; }
td small { color: #64748b; }
.r { text-align: right; }
tr { break-inside: avoid; }
.tot { width: 46%; margin: 14px 0 0 auto; }
.tot td { border: 0; padding: 4px 8px; }
.tot tr.net td { border-top: 2px solid #1e3a8a; font-size: 14px; font-weight: 800; color: #1e3a8a; }
.tot tr.bal td { font-weight: 800; color: #b91c1c; }
.note { margin-top: 18px; padding-top: 8px; border-top: 1px solid #cbd5e1; color: #64748b; font-size: 10px; }
</style></head><body>
<div class="top">
  <div><h1>${esc(g('centreName') || 'Laboratory')}</h1><div class="sub">${esc(g('centreCode') || '')}</div></div>
  <div class="doc"><div class="t">INVOICE</div><div>No: <b>${esc(g('invoiceNumber'))}</b></div><div>Date: <b>${esc(day(g('invoiceDate')))}</b></div><div>Due: <b>${esc(day(g('dueDate')))}</b></div></div>
</div>
<div class="cols">
  <div class="box"><h4>Billed to</h4><div><b>${esc(g('partyName'))}</b> ${g('partyCode') ? `(${esc(g('partyCode'))})` : ''}</div><div>${esc(g('partyAddress') || '')}</div>
    <div>GSTIN: ${esc(g('partyGstNumber') || '—')} &bull; PAN: ${esc(g('partyPanNumber') || '—')}</div></div>
  <div class="box"><h4>Billing period</h4><div>${esc(day(g('billingPeriodFrom')))} &ndash; ${esc(day(g('billingPeriodTo')))}</div>
    <div>Orders: <b>${esc(g('totalOrders') ?? items.length)}</b> &bull; Tests: <b>${items.length}</b></div><div>Status: <b>${esc(g('status') || 'UNPAID')}</b></div></div>
</div>
<table>
<thead><tr><th>#</th><th>Lab No</th><th>Patient</th><th>Investigation</th><th>SAC</th><th class="r">Rate</th><th class="r">Discount</th><th class="r">Amount</th></tr></thead>
<tbody>${rows}</tbody>
</table>
<table class="tot">
<tr><td>Gross amount</td><td class="r">${money(g('grossAmount'))}</td></tr>
<tr><td>Discount</td><td class="r">${money(g('discountAmount'))}</td></tr>
<tr><td>Taxable amount</td><td class="r">${money(g('taxableAmount'))}</td></tr>
<tr><td>CGST / SGST / IGST</td><td class="r">${money(g('cgstAmount'))} / ${money(g('sgstAmount'))} / ${money(g('igstAmount'))}</td></tr>
<tr class="net"><td>Net amount (₹)</td><td class="r">${money(g('netAmount'))}</td></tr>
<tr><td>Paid</td><td class="r">${money(g('paidAmount'))}</td></tr>
<tr class="bal"><td>Balance due (₹)</td><td class="r">${money(g('balanceAmount'))}</td></tr>
</table>
<div class="note">Healthcare services (SAC 999312). Computer generated invoice, no signature required. Please quote the invoice number with your payment.</div>
</body></html>`;
  printHtml(html);
}
